import React from 'react';

import { Field, FieldConfig, FormikErrors } from 'formik';

import { useStyles } from '../../Themable.hooks';

import { restGetTimezoneDictionary } from '../../../../../../services/registers';
import { restGetGroups } from '../../../../../../services/groups';

import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { trimValue } from '../../../../../../helpers/TrimValuesHelper';

import AsyncSelectField from '../../../../../../components/AsyncSelectField';
import CustomAutocomplete from '../../../../../../components/common/CustomAutocomplete';

import { IHeaderData, TMonitoredObjectDataForm } from '../../types';
import { fields } from '../../utils/fields';
import FieldWrapper from '../../../../../../components/common/formikWrappers/FieldWrapper';

interface IFormField extends FieldConfig {
    required?: boolean;
}

interface IOwnProps {
    headerData: IHeaderData;
    values: TMonitoredObjectDataForm;
    errors: FormikErrors<TMonitoredObjectDataForm>;
    setFieldValue: (fieldname: string, v: any) => void;
}
const EditObjectDataForm = ({
    headerData,
    values,
    errors,
    setFieldValue,
}: IOwnProps) => {
    const classes = useStyles();
    const { type } = headerData;
    return (
        <div className={classes.paneContent}>
            {fields[type](errors, classes)?.map(
                (field: IFormField, index: number) => {
                    if (field.type === 'name') {
                        return (
                            <Field
                                key={'name'}
                                error={!!errors?.name}
                                helperText={errors?.name}
                                name={'data.name'}
                                label={TranslationHelper.translate(
                                    'Object name'
                                )}
                                type="text"
                                component={FieldWrapper}
                                required={true}
                                fullWidth
                            />
                        );
                    }
                    if (field.type === 'timeZone') {
                        return (
                            <AsyncSelectField
                                key={'field' + index}
                                label={TranslationHelper.translate('Time zone')}
                                getOptions={restGetTimezoneDictionary}
                                error={errors?.timeZone}
                                onChange={(e, value) =>
                                    setFieldValue('timeZone', value)
                                }
                                value={values.timeZone}
                                disableClearable={true}
                            />
                        );
                    }

                    if (field.type === 'groups') {
                        return (
                            <CustomAutocomplete
                                key={'field' + index}
                                value={values.groups || []}
                                inputTexts={{
                                    placeholder: 'Select group',
                                }}
                                label={TranslationHelper.translate('Group')}
                                multi
                                onChange={(e, value) => {
                                    setFieldValue('data.groups', value);
                                }}
                                error={errors?.groups}
                                onOpen={restGetGroups}
                                required={field.required}
                                optionKeys={{
                                    name: 'name',
                                    value: 'id',
                                }}
                            />
                        );
                    }
                    return (
                        <Field
                            {...field}
                            name={`data.registry.${field.name}`}
                            error={!!errors?.[`registry.${field.name}`]}
                            helperText={errors?.[`registry.${field.name}`]}
                            key={'field' + index}
                            onBlur={(event: any) => {
                                if (typeof event.target.value === 'string') {
                                    trimValue(event, setFieldValue);
                                }
                            }}
                        />
                    );
                }
            )}
        </div>
    );
};

export default EditObjectDataForm;
